var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1967 23.1969C3.60322 21.7904 5.51087 21.0002 7.49999 21.0002H19.5C21.4891 21.0002 23.3967 21.7904 24.8033 23.1969C26.2098 24.6035 27 26.5111 27 28.5002V31.5002C27 32.3287 26.3284 33.0002 25.5 33.0002C24.6715 33.0002 24 32.3287 24 31.5002V28.5002C24 27.3068 23.5259 26.1622 22.6819 25.3183C21.838 24.4743 20.6934 24.0002 19.5 24.0002H7.49999C6.30652 24.0002 5.16193 24.4743 4.31801 25.3183C3.4741 26.1622 2.99999 27.3068 2.99999 28.5002V31.5002C2.99999 32.3287 2.32842 33.0002 1.5 33.0002C0.671572 33.0002 0 32.3287 0 31.5002V28.5002C0 26.5111 0.790176 24.6035 2.1967 23.1969Z",
    fill: "#121D2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.5001C6 6.35798 9.35786 3.00012 13.5 3.00012C17.6421 3.00012 21 6.35798 21 10.5001C21 14.6422 17.6421 18.0001 13.5 18.0001C9.35786 18.0001 6 14.6422 6 10.5001Z",
    fill: "#121D2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.548 22.3199C28.7551 21.5178 29.5732 21.0355 30.3754 21.2426C31.9843 21.658 33.4098 22.5961 34.4279 23.9094C35.446 25.2228 35.9991 26.8371 36.0003 28.4988L36.0004 31.4999C36.0004 32.3284 35.3288 32.9999 34.5004 32.9999C33.6719 32.9999 33.0004 32.3284 33.0004 31.4999L33.0004 28.501C33.0004 28.5009 33.0004 28.5012 33.0004 28.501C32.9995 27.5041 32.6677 26.5353 32.0569 25.7474C31.446 24.9594 30.5908 24.3966 29.6254 24.1473C28.8232 23.9402 28.3409 23.1221 28.548 22.3199Z",
    fill: "#121D2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5472 4.323C22.7527 3.52047 23.5699 3.03646 24.3724 3.24194C25.9857 3.655 27.4156 4.59325 28.4367 5.90877C29.4579 7.22428 30.0121 8.84223 30.0121 10.5076C30.0121 12.1729 29.4579 13.7908 28.4367 15.1063C27.4156 16.4219 25.9857 17.3601 24.3724 17.7732C23.5699 17.9786 22.7527 17.4946 22.5472 16.6921C22.3418 15.8896 22.8258 15.0724 23.6283 14.8669C24.5963 14.6191 25.4542 14.0561 26.0669 13.2668C26.6796 12.4775 27.0121 11.5067 27.0121 10.5076C27.0121 9.50836 26.6796 8.53759 26.0669 7.74828C25.4542 6.95897 24.5963 6.39602 23.6283 6.14818C22.8258 5.9427 22.3418 5.12554 22.5472 4.323Z",
    fill: "#121D2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndUser);
export default __webpack_public_path__ + "static/media/end-user.7514d69213e8af159e9fd1c827960d2d.svg";
export { ForwardRef as ReactComponent };